// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1HKrM","upload":"Small_upload__38HM_","imageWrap":"Small_imageWrap__MXeQE","removeBtn":"Small_removeBtn__1eSaU"};